import { render, staticRenderFns } from "./SeminarReview.vue?vue&type=template&id=29624f91&scoped=true&"
import script from "./SeminarReview.vue?vue&type=script&lang=js&"
export * from "./SeminarReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29624f91",
  null
  
)

export default component.exports